import classNames from "classnames";
import styles from "./app-popups.module.scss";
import {shareState} from "../../share-state";
import {observer} from 'mobx-react';
import {Popup} from "../../../components/popup/popup";
import {useState, useRef, useEffect} from "react";
import {Image} from "../../../components/image/image";
import {CocaColaPrizeImageRequestParams} from "../../../icons/coca-cola-prize";

export const AppCocaColaPrizePopup = observer(({controller}) => {
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const ref = useRef();

  const onClick = (url) => {
    shareState.isWebView ? shareState.nativeFunctionsUtils.callFunction("openBrowser", {url}) : window.open(url);
  }

  useEffect(() => {
    if (!shareState.shouldRenderCocaColaPrizePopup || !ref.current) {
      return;
    }

    // Use setTimeout to ensure the DOM is fully rendered after dangerouslySetInnerHTML
    const timeoutId = setTimeout(() => {
      const children = ref.current?.children;
      if (children) {
        const arr = [].slice.call(children);

        arr?.forEach((child) => {
          if (child.dataset.url) {
            child.onclick = (e) => {
              e.preventDefault();
              onClick(child.dataset.url);
            }
            child.style.cursor = 'pointer';
          }
        })
      }
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [shareState.shouldRenderCocaColaPrizePopup]);

  const popupProps = {
    className: classNames(styles.cocacola_prize_popup_container, {[styles.mobile_view]: shareState.isMobileView}),
    onClose: () => {
      controller.closeCocaColaPrizePopup();
    },
    hasBgCloseButton: true
  }

  const imageProps = {
    className: classNames(styles.prize_image),
    src: new CocaColaPrizeImageRequestParams()
  }

  const checkboxProps = {
    type: "checkbox",
    checked: isCheckboxChecked,
    className: classNames(styles.checkbox),
    onChange: (e) => setIsCheckboxChecked(e.target.checked)
  }

  const promoRegulationProps = {
    className: classNames(styles.promo_regulation_text),
    dangerouslySetInnerHTML: {
      __html: shareState.termsUtils.terms.BOLAO_PROMO_REGULATION_ACCEPTION
        .replaceAll('<a', '<div')
        .replaceAll('</a>', '</div>')
        .replaceAll('href', 'data-url')
    },
    ref
  }

  const buttonProps = {
    className: classNames(styles.popup_button, {[styles.disabled]: !isCheckboxChecked}),
    onClick: () => {
      if (isCheckboxChecked) {
        controller.acceptCocaColaPrizePopup();
      }
    },
  }

  return (
    shareState.shouldRenderCocaColaPrizePopup ?
      <Popup {...popupProps}>
        <Image {...imageProps}/>
        <div className={classNames(styles.promo_checkbox_container)}>
          <input {...checkboxProps}/>
          <div {...promoRegulationProps}/>
        </div>
        <div {...buttonProps}>{shareState.termsUtils.terms.BOLAO_PROMO_REGULATION_ACCEPTION_BUTTON}</div>
      </Popup> : null
  );
});
